import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import NotificationsMenu from "./ViewNotifications";
import ViewTrash from "./ViewTrash";
import Message from "./Message";

const RoutesNotifications = () => {
    return (
        <>
            <Route
                path="notifications"
                element={
                    <PrivateRoute>
                        <NotificationsMenu />
                    </PrivateRoute>
                }
            />
            <Route
                path="notifications/message"
                element={
                    <PrivateRoute>
                        <Message />
                    </PrivateRoute>
                }
            />
            <Route
                path="notifications/trash"
                element={
                    <PrivateRoute>
                        <ViewTrash />
                    </PrivateRoute>
                }
            />
        </>
    );
};
export default RoutesNotifications;
